import { render, staticRenderFns } from "./HostRoles.vue?vue&type=template&id=6e8c8f75&"
import script from "./HostRoles.vue?vue&type=script&lang=ts&"
export * from "./HostRoles.vue?vue&type=script&lang=ts&"
import style0 from "./HostRoles.vue?vue&type=style&index=0&id=6e8c8f75&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports